import { render, staticRenderFns } from "./PaymentsSummary.vue?vue&type=template&id=5c75cee5&"
import script from "./PaymentsSummary.vue?vue&type=script&lang=js&"
export * from "./PaymentsSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports